<template>
  <b-modal 
    id="modal-confirmation-course" 
    centered 
    hide-footer
    title="Confirmation Course"
    size="lg"
    body-class="p-0">
    <div class="p-4">
      <!-- Batch Title -->
      <h6 class="font-weight-bold mb-3">Training Event Realization</h6>

      <!-- Form -->
      <div class="row">
        <!-- Left Column -->
        <div class="col-md-6">
          <!-- Course Method (Disabled) -->
          <div class="mb-3">
            <label class="form-label small">
              Course Method
            </label>
            <input 
              type="text" 
              class="form-control" 
              :value="batchData?.training_method_name || '-'"
              disabled>
          </div>

          <!-- Accommodation Price (Hotel) - Realized -->
          <div class="mb-3">
            <label class="form-label small">
              Realized Accommodation Price (Hotel)<span class="text-danger">*</span>
            </label>
            <CurrencyInput
              v-model="formData.realized_accomodation_price"
              :currency.sync="formData.realized_accomodation_price_currency"
              placeholder="1000000"
            />
          </div>

          <!-- Location (Disabled) -->
          <div class="mb-3">
            <label class="form-label small">
              Location
            </label>
            <input 
              type="text" 
              class="form-control" 
              :value="batchData?.location || '-'"
              disabled>
          </div>
        </div>

        <!-- Right Column -->
        <div class="col-md-6">
          <!-- Course Price - Realized -->
          <div class="mb-3">
            <label class="form-label small">
              Realized Course Price<span class="text-danger">*</span>
            </label>
            <CurrencyInput
              v-model="formData.realized_course_price"
              :currency.sync="formData.realized_course_price_currency"
              placeholder="4000000"
            />
          </div>

          <!-- Transport Price (Ticket & Others) - Realized -->
          <div class="mb-3">
            <label class="form-label small">
              Realized Transport Price (Ticket & Others)<span class="text-danger">*</span>
            </label>
            <CurrencyInput
              v-model="formData.realized_transportation_price"
              :currency.sync="formData.realized_transportation_price_currency"
              placeholder="700000"
            />
          </div>

          <!-- Quota Participant (Disabled) -->
          <div class="mb-3">
            <label class="form-label small">
              Quota Participant
            </label>
            <input 
              type="text" 
              class="form-control" 
              :value="batchData?.quota || '-'"
              disabled>
          </div>
        </div>
      </div>

      <!-- Divider -->
      <hr class="my-4">

      <!-- Submit Button -->
      <div class="d-flex justify-content-end gap-3">
        <button 
          class="btn px-4 py-2" 
          @click="closeModal"
          style="background-color: #fce4e4; color: #e63757; border: none; font-weight: 500; border-radius: 6px;">
          Cancel
        </button>
        <button 
          class="btn px-4 py-2" 
          @click="submitConfirmation"
          :disabled="isSubmitting"
          style="background-color: #e63757; color: white; border: none; font-weight: 500; border-radius: 6px;">
          <span v-if="isSubmitting">
            <span class="spinner-border spinner-border-sm me-2"></span>
            Mengirim...
          </span>
          <span v-else>Submit</span>
        </button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { mapActions } from 'vuex';
import CurrencyInput from '@/components/CurrencyInput.vue';

export default {
  name: 'ModalConfirmationCourse',
  components: {
    CurrencyInput
  },
  props: {
    batchData: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      isSubmitting: false,
      formData: {
        realized_course_price: null,
        realized_accomodation_price: null,
        realized_transportation_price: null,
        realized_course_price_currency: 'IDR',
        realized_accomodation_price_currency: 'IDR',
        realized_transportation_price_currency: 'IDR'
      }
    }
  },
  watch: {
    batchData: {
      immediate: true,
      handler(newData) {
        console.log('🔔 ModalConfirmationCourse: batchData changed:', newData);
        if (newData) {
          // Populate with existing realized prices if available, or use planned prices as default
          this.formData.realized_course_price = newData.realized_course_price || newData.course_price || null;
          this.formData.realized_accomodation_price = newData.realized_accomodation_price || newData.accomodation_price || null;
          this.formData.realized_transportation_price = newData.realized_transportation_price || newData.transportation_price || null;
          
          // Set currencies
          this.formData.realized_course_price_currency = newData.realized_course_price_currency || newData.course_price_currency || 'IDR';
          this.formData.realized_accomodation_price_currency = newData.realized_accomodation_price_currency || newData.accomodation_price_currency || 'IDR';
          this.formData.realized_transportation_price_currency = newData.realized_transportation_price_currency || newData.transportation_price_currency || 'IDR';
          
          console.log('✅ Form populated:', this.formData);
        }
      }
    }
  },
  mounted() {
    console.log('✅ ModalConfirmationCourse mounted');
    
    // Listen for modal show event
    this.$root.$on('bv::modal::show', (bvEvent, modalId) => {
      if (modalId === 'modal-confirmation-course') {
        console.log('📂 Modal confirmation course is showing...');
      }
    });
  },
  beforeDestroy() {
    this.$root.$off('bv::modal::show');
  },
  methods: {
    ...mapActions('courseCatalog', ['submitTrainingEvent']),
    
    closeModal() {
      this.$bvModal.hide('modal-confirmation-course');
    },

    async submitConfirmation() {
      // Validate required fields
      if (!this.formData.realized_course_price || 
          !this.formData.realized_accomodation_price || 
          !this.formData.realized_transportation_price) {
        this.$swal('Error', 'Lengkapi semua kolom wajib', 'error');
        return;
      }

      if (!this.batchData || !this.batchData.id) {
        this.$swal('Error', 'Data batch tidak ditemukan', 'error');
        return;
      }

      try {
        this.isSubmitting = true;

        // Prepare payload
        const payload = {
          realized_course_price: Number(this.formData.realized_course_price),
          realized_accomodation_price: Number(this.formData.realized_accomodation_price),
          realized_transportation_price: Number(this.formData.realized_transportation_price),
          realized_course_price_currency: this.formData.realized_course_price_currency,
          realized_accomodation_price_currency: this.formData.realized_accomodation_price_currency,
          realized_transportation_price_currency: this.formData.realized_transportation_price_currency
        };

        console.log('📤 Submitting training event:', this.batchData.id, payload);

        // Call API
        await this.submitTrainingEvent({ 
          id: this.batchData.id, 
          data: payload 
        });

        // Show success message
        this.$swal('Success', 'Realisasi event pelatihan berhasil dikirim', 'success');
        
        // Emit success event to parent
        this.$emit('submitted-success');
        
        // Close modal
        this.closeModal();
      } catch (error) {
        console.error('Error submitting training event:', error);
        this.$swal('Error', error.response?.data?.message || 'Event pelatihan belum berhasil dikirim', 'error');
      } finally {
        this.isSubmitting = false;
      }
    }
  }
}
</script>

<style scoped>
.btn-close {
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
  opacity: 0.7;
  transition: opacity 0.2s;
}

.btn-close:hover {
  opacity: 1;
}
</style>
